<template>
  <b-row class="widget-row widget-row--grid">
    <b-col cols="12" xl="5" class="widget-col">
      <div class="widget project-progress h-100">
        <b-tabs class="b-hack">
          <b-tab title="Project Progress" active title-link-class="card-tab__label">
            <ByMonthGraph :data="gradeByMonthDataLimited" @update="onMonthUpdate" />
          </b-tab>
          <b-tab title="Participation" title-link-class="card-tab__label">
            <ParticipationGraph
              :data="participationDataLimited"
              @update="onMonthUpdateParticipation"
            />
          </b-tab>
        </b-tabs>
      </div>
    </b-col>
    <b-col cols="12" xl="7" class="widget-col">
      <b-row class="widget-row mb-0 h-100">
        <b-col cols="6" class="widget-col">
          <div class="widget safety h-100">
            <MetricBox title="Safety Innovations" :data="safetyInnovations.length" featured />
          </div>
        </b-col>
        <b-col cols="3" class="widget-col">
          <div class="widget saved-days h-100">
            <MetricBox
              :title="getScheduleTitle"
              :data="daysSaved"
              :compText="getScheduleText"
              :compData="getScheduleRatio"
              :compDirectionFunc="() => '&#9650;'"
            />
          </div>
        </b-col>
        <b-col cols="3" class="widget-col">
          <div class="widget saved-budget h-100">
            <MetricBox
              title="Dollars Saved"
              :data="dollarsSaved"
              :isCurrency="true"
              :compText="getBudgetText"
              :compData="getBudgetRatio"
            />
          </div>
        </b-col>
        <b-col cols="3" class="widget-col mb-0">
          <div class="widget risks h-100">
            <MetricBox title="Risks Mitigated" :data="closedRisks.length" />
          </div>
        </b-col>
        <b-col cols="3" class="widget-col mb-0">
          <div class="widget resolved-issues h-100">
            <MetricBox title="Issues Resolved" :data="closedIssues.length" />
          </div>
        </b-col>
        <b-col cols="3" class="widget-col mb-0">
          <div class="widget efficiencies h-100">
            <MetricBox title="Efficiencies" :data="efficiencies.length" />
          </div>
        </b-col>
        <b-col cols="3" class="widget-col mb-0">
          <div class="widget modality h-100">
            <MetricBox title="Innovations" :data="innovations.length" />
          </div>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
import ByMonthGraph from "@/components/project/ByMonthGraph.vue";
import ParticipationGraph from "@/components/project/ParticipationGraph.vue";
import MetricBox from "@/sub-components/MetricBox.vue";

export default {
  name: "ProjectMetricsSection",
  components: {
    ByMonthGraph,
    ParticipationGraph,
    MetricBox,
  },
  props: {
    projectSummary: {
      type: Object,
      required: true,
    },
    projectMetrics: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      byMonthLimit: 6,
      byMonthParticipationLimit: 6,
    };
  },
  methods: {
    //This is the number which is selected from Drop Down 3,6,12 months for Project Progress
    onMonthUpdate(months) {
      this.byMonthLimit = months;
    },
    //This is the number which is selected from Drop Down 3,6,12 months for Participation
    onMonthUpdateParticipation(months) {
      this.byMonthParticipationLimit = months;
    },
    addParticipationTooltip(data) {
      if (data.length > 1) {
        //Add tooltip to first row
        data[0].splice(3, 0, {
          type: "string",
          role: "tooltip",
          p: { html: true },
        }); //index 3 and last index, 6
        data[0].push({ type: "string", role: "tooltip", p: { html: true } });

        for (var i = 1; i < data.length; i++) {
          let row = data[i];
          let period = row[0];
          for (var j = 1; j <= 4; j += 3) {
            let role = data[0][j].label;
            let value = row[j];
            let text = this.participationTooltip(period, role, value || 0);
            row.splice(j + 2, 0, text);
          }
        }
      }
    },
    participationTooltip(period, role, value) {
      return `<ul class="google-visualization-tooltip-item-list">
                <li class="google-visualization-tooltip-item">
                  <span style="font-family:Arial;font-size:12px;color:#000000;opacity:1;margin:0;font-style:none;text-decoration:none;font-weight:bold;">${period}</span>
                </li>
                <li class="google-visualization-tooltip-item">
                  <span style="font-family:Arial;font-size:12px;color:#000000;opacity:1;margin:0;font-style:none;text-decoration:none;font-weight:none;">${role}:</span>
                  <span style="font-family:Arial;font-size:12px;color:#000000;opacity:1;margin:0;font-style:none;text-decoration:none;font-weight:bold;">
                    ${(value * 100).toFixed(2) + "%"}</span>
                </li>
              </ul>`;
      // return '<div style="color: Red;">Test</div>';
    },
  },
  computed: {
    gradeByMonthDataLimited() {
      let gradeByMonthData = this.$helpers.mapDataPointToChartDataSet(
        this.projectSummary.responsesByMonth
      );

      if (gradeByMonthData.length > this.byMonthLimit + 1) {
        return [gradeByMonthData[0]].concat(
          gradeByMonthData.slice(-1 * this.byMonthLimit)
        );
      } else {
        return gradeByMonthData;
      }
    },
    participationDataLimited() {
      let participationData = this.$helpers.mapDataPointToChartDataSet(
        this.projectSummary.participationByMonth,
        4
      );
      this.addParticipationTooltip(participationData);

      if (participationData.length > this.byMonthParticipationLimit + 1) {
        return [participationData[0]].concat(
          participationData.slice(-1 * this.byMonthParticipationLimit)
        );
      } else {
        return participationData;
      }
    },

    safetyInnovations() {
      return this.innovations.filter(
        (p) => p.tags && p.tags.toLowerCase().includes("safety")
      );
    },
    innovations() {
      return this.projectMetrics.filter((p) => p.type === "Innovation");
    },

    dollarsSaved() {
      return this.projectMetrics.reduce(
        (prev, cur) =>
          prev + (cur.costSaved && !isNaN(cur.costSaved) ? cur.costSaved : 0),
        0
      );
    },
    getBudgetText() {
      return this.getBudgetRatio > 0
        ? "Over Budget"
        : this.getBudgetRatio < 0
        ? "Under Budget"
        : "";
    },
    getBudgetRatio() {
      let cost = this.projectSummary.project.projectCost;
      let saved = this.dollarsSaved;
      return cost && saved && cost > 0 ? parseFloat((-1 * saved) / cost) : 0;
    },

    daysSaved() {
      return this.projectMetrics.reduce(
        (prev, cur) =>
          prev + (cur.timeSaved && !isNaN(cur.timeSaved) ? cur.timeSaved : 0),
        0
      );
    },
    getScheduleText() {
      return this.getScheduleRatio > 0
        ? "Behind Schedule"
        : this.getScheduleRatio < 0
        ? "Ahead of Schedule"
        : "";
    },
    getScheduleRatio() {
      let saved = this.daysSaved;
      let schedule = this.$formatter.daysFromDates(
        this.projectSummary.project.startDate,
        this.projectSummary.project.endDate
      );

      return schedule && saved && schedule > 0
        ? parseFloat((-1 * saved) / schedule)
        : 0;
    },
    getScheduleTitle() {
      return this.getScheduleRatio <= 0
        ? "Days Saved"
        : "Days Behind";
    },

    closedIssues() {
      return this.projectMetrics.filter(
        (p) => p.type === "Issue" && p.status === "Closed"
      );
    },
    efficiencies() {
      return this.projectMetrics.filter((p) => p.type === "Efficiency");
    },
    closedRisks() {
      return this.projectMetrics.filter(
        (p) => p.type === "Risk" && p.status === "Closed"
      );
    },
  },
};
</script>

<style lang="scss">
.widget {
  // &.safety {
  //   background: red;
  // }
  &.safety,
  &.saved-budget,
  &.saved-days,
  &.resolved-issues,
  &.modality,
  &.efficiencies,
  &.risks {
    .card-title {
      word-wrap: normal;
      margin: 0 -24px !important;
    }
    .profit-indicator p {
      word-wrap: normal;
      margin: 0 -12px !important;
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      column-gap: 8px;
      span {
        padding: 0 !important;
      }
    }
  }
}
</style>